import * as React from 'react'

export type InitialContextType = { [key: string]: any }

const StoreValuesContext: React.Context<InitialContextType> = React.createContext({})

export default StoreValuesContext
